export { PromoteCommand } from './PromoteCommand.js';
